import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export default function Accordion({ items }) {
  const [open, setOpen] = useState(null);

  return (
    <div className="faq-list" data-testid="faq-list">
      {items.map((item, idx) => {
        const isOpen = open === idx;
        return (
          <div
            key={item.q}
            className={`faq-item ${isOpen ? "faq-item-open" : ""}`}
            data-testid={`faq-item-${idx}`}
          >
            <button
              className="faq-question"
              onClick={() => setOpen(isOpen ? null : idx)}
              aria-expanded={isOpen}
              data-testid={`faq-question-${idx}`}
            >
              <span>{item.q}</span>
              <Plus
                size={18}
                className={`faq-icon ${isOpen ? "faq-icon-open" : ""}`}
              />
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                  style={{ overflow: "hidden" }}
                >
                  <div className="faq-answer" data-testid={`faq-answer-${idx}`}>
                    {item.a}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
